exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flatpickr[data-v-4fbb5c14]{position:relative}.input[data-v-4fbb5c14]{display:none}", ""]);

// exports
